import TabDrawers from 'components/tab-drawer';
import styles from './search-section.module.scss';
import SearchWrapper from './search-wrapper';
import { useState } from 'react';
import CloseIcon from 'assets/icons/close-x.svg';
import { routes } from '@metmuseum/routes';
import {
	trackCollectionSearchSubmitted,
	trackSiteSearchSubmitted,
} from 'lib/analytics/trackSearch';
import useIsHydrated from 'hooks/use-is-hydrated';

const SearchSection = ({
	toggleVisible,
	isVisibleOnLoad = false,
}: SearchSectionProps) => {
	const [searchText, setSearchText] = useState(undefined);

	const isHydrated = useIsHydrated();
	const classes = isHydrated
		? `${styles.wrapper} ${styles.isVisible}`
		: `${styles.wrapper} ${isVisibleOnLoad ? styles.isVisible : ''}`;

	const handleSearchTextChange = (event) => {
		setSearchText(event.target.value);
	};

	return (
		<div className={classes} data-lock-page={true}>
			<div className={styles.tabWrapper}>
				<TabDrawers
					tabBodyWrapperClass={styles.tabDrawer}
					hasDivider={false}
					tabs={[
						{
							name: 'Search art',
							body: (
								<div className={styles.search}>
									<SearchWrapper
										baseUrl={routes.advancedCollectionSearch()}
										onChange={handleSearchTextChange}
										onSearchSubmit={({ searchTerm }) =>
											trackCollectionSearchSubmitted({
												searchOrigin: 'Global Nav',
												searchTerm,
											})
										}
										searchText={searchText}
									/>
								</div>
							),
						},
						{
							name: 'Search the website',
							body: (
								<div className={styles.search}>
									<SearchWrapper
										baseUrl={`/search-results`}
										onChange={handleSearchTextChange}
										onSearchSubmit={({ searchTerm }) =>
											trackSiteSearchSubmitted({
												searchOrigin: 'Global Nav',
												searchTerm,
											})
										}
										searchText={searchText}
									/>
								</div>
							),
						},
					]}
					inputGroupName={'site-search-tabs'}
					screenreaderLegendText="Provides options to perform a text search of either The Met's online collection or general website content."
				/>
			</div>
			<button
				type="button"
				aria-label="Close Search"
				title="Close Search"
				onClick={() => toggleVisible(false)}
				className={styles.close}
			>
				<CloseIcon aria-hidden="true" />
			</button>
		</div>
	);
};

type SearchSectionProps = {
	toggleVisible: (isVisible: boolean) => void;
	isVisibleOnLoad?: boolean;
};

export default SearchSection;
